import React from "react";
import Services from "./Services";
import GetApp from "./GetApp";
import ReviewCard from "./Components/ReviewCard";
import AboutHelper from "./Components/AboutHelper";

const Home = () => {
  return (
    <div className="w-full h-auto">
      <div className="flex flex-col space-y-5 md:space-y-0 md:flex-row items-end lg:items-center justify-between w-full min-h-[60] pt-5 bg-[#11120F] ">
        <div className="w-full md:w-1/2 flex flex-col px-5 space-y-6 py-5">
          <p className="text-[#FBB034] text-lg font-normal font-be-jost-pro w-full text-center lg:text-left">
          Welcome to the official website of Barbera
          </p>
          <h3 className="font-poppins text-5xl font-bold text-white text-center lg:text-left">
          Professional Unisex Salon Services At Your Home
          </h3>
          <p className="font-poppins text-xl font-light text-[#9A9A9A] w-full lg:w-1/2">
          Need Haircut , Shaving , Waxing , Facial , Haircare or any other salon services at your home? Book an appointment now!

          </p>
          <a href="/contact" className="bg-[#FBB034] w-full  lg:w-2/5 py-3 rounded-md font-bold text-center">
          <button>
            Book An Appointment
          </button>
          </a>
        </div>
        <div className="w-full md:w-[45%] flex justify-end ">
          <img src="/Assets/homepage-1.png" className="m-0 " />
        </div>
      </div>

      {/* <div className="flex flex-col-reverse md:flex-row items-center justify-around w-full min-h-[60] py-16 px-3 md:px-0 bg-[#202125] ">
        <img
          src="/Assets/homepage-2.png"
          className="w-full md:w-1/2 lg:w-1/3 mt-16 md:mt-0"
        />
        <div className="flex flex-col items-start justify-center w-full md:w-1/3 space-y-6">
          <p className="text-[#FBB034] text-lg font-normal font-be-jost-pro w-full text-center md:text-left">
            About Us
          </p>
          <p className="font-be-jost-profont-normal text-base text-[#9A9A9A]">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged.
          </p>
          <button className="bg-[#FBB034] w-full md:w-2/5 py-3 rounded-md font-bold">
            Learn More
          </button>
        </div>
      </div> */}

      <AboutHelper />

      <Services />

      <div className="flex flex-col items-center justify-center w-full min-h-[60] py-16 bg-[#202125] space-y-10">
        <div className="flex flex-col items-center justify-end space-y-5 w-full px-2 md:px-4 md:w-2/5 lg:w-[60%]">
          <h3 className="font-be-jost-pro text-3xl font-semibold text-white">
            Our <span className="text-[#FBB034]">Clients</span>
          </h3>
          <p className="text-[#9A9A9A] font-be-jost-pro text-xl font-normal text-center">
          Here are some kind words straight from our clients. Read on!
          </p>
        </div>
        <div className="flex flex-col md:flex-row space-y-6 md:space-y-0 space-x-0 items-center justify-center md:space-x-10 w-full">
          {/* <div className="flex flex-col bg-[#11120F] rounded-md w-1/4 py-4 px-14 items-center space-y-3">
            <img src="/Assets/profileImage.png" className="w-9" />
            <div className="flex w-full justify-center items-center space-x-4">
              <img src="/Assets/goldStar.png" />
              <img src="/Assets/goldStar.png" />
              <img src="/Assets/goldStar.png" />
              <img src="/Assets/goldStar.png" />
              <img src="/Assets/goldStar.png" />
            </div>
            <p className="font-be-jost-pro font-normal text-xs italic text-center text-[#9A9A9A]">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy{" "}
            </p>
            <p className="font-be-jost-pro font-normal text-lg text-white ">
              Scott Headerson
            </p>
            <p className="font-be-jost-pro font-normal text-sm text-[#FBB033] ">
              Customer
            </p>
          </div> */}
          <ReviewCard primaryBg={"black"} name={"Naresh Kumar Meena, Lawyer, Jaipur"} description={"Got the best shave and facial ever! Thanks, team Barbera. You guys are awesome. As a single man living in Mumbai alone, I hardly find time to take care of my grooming needs. However, now that I know where I would have to head over to get the best look, I can now rest assured. See you soon!"}/>
          <ReviewCard primaryBg={"yellow"} name={"Himanshu Agarwal, Jaipur"} description={"These guys know what they are doing, FR! I have had quite a few appointments with other similar service providers in the past but they all ended up offering sub-standard services for the money they were charging. Not Team Barbera. The tariffs are reasonable and you would get more than you are paying for! I am recommending you guys to all my friends!"}/>
          <ReviewCard primaryBg={"black"} name={"Preeti Pandey, Jaipur"} description={"I ordered a facial cleaning session and a body massage session once and that single experience was enough for me to become a regular customer of Barbera. I hope you guys will keep your quality standards consistent for the decades to come!"}/>
        </div>
      </div>

      <div className="flex items-center justify-center w-full min-h-[60] py-5 bg-[#11120F] ">
        <div className="flex flex-col items-center justify-end space-y-5 w-full px-2 md:px-4 md:w-2/5 lg:w-[60%]">
          <h3 className="font-be-jost-pro text-3xl font-semibold text-white">
            Install our <span className="text-[#FBB034]">App</span>
          </h3>
          <p className="text-[#9A9A9A] font-be-jost-pro text-xl font-normal text-center ">
          Don’t want to use your clunky tablet or your laptop to book sessions at Barbera!? Don’t worry; you can install our official app.
          </p>
        </div>
      </div>
      <GetApp />
    </div>
  );
};

export default Home;
